<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<div>
  <router-outlet> </router-outlet>
</div>

<div class="alertMessage" id="alertMessage">
  <span class="closebtn" onclick="this.parentElement.style.display='none';">&times;</span>
  <strong>Internet or API failure!</strong> <br/> Please check your Internet or API.
</div>

<notifier-container></notifier-container>

<!-- Loader Spinner widget -->
<div class="loaderDiv" id="loaderSpinner">
  <mat-spinner style="position: absolute;left: 50%;top: 50%;"></mat-spinner>
</div>
